// extracted by mini-css-extract-plugin
export var orderSummary = "_j1-0";
export var showMoreLessButton = "_j1-1";